// Tracks how many Dialog/Confirm scrims are currently open, so Aurora
// (Aurora.tsx) can pause its ambient drift while any scrim is up. A static
// aurora means the sidebar/scrim/dialog glass above it has nothing changing
// underneath to recompute every frame — see DESIGN_SYSTEM.md §5.5 discussion.
// Counter (not a boolean) so stacked dialogs (e.g. a Confirm opened on top of
// a Dialog) resume aurora only once every scrim has closed. Drawer doesn't
// register separately — it only ever renders inside a Dialog (see
// RockDetailModal.tsx), so its scrim is already covered by the parent's count.
import { create } from 'zustand';

interface ScrimState {
  openCount: number;
  registerOpen: () => void;
  registerClose: () => void;
}

/** Dialog-private transient implementation state; never persisted or shared with product modules. */
export const useScrimStore = create<ScrimState>((set) => ({
  openCount: 0,
  registerOpen: () => set((s) => ({ openCount: s.openCount + 1 })),
  registerClose: () => set((s) => ({ openCount: Math.max(0, s.openCount - 1) })),
}));
